import React from 'react'

const EmptyView = () => {
  return (
    <div>
      <h1>EmptyView</h1>
    </div>
  )
}

export default EmptyView
